import { saveResource } from 'containers/Resources/actions';
import { isResourceSaved } from 'containers/Resources/utils';
import { useDispatch, useSelector } from 'react-redux';
import { trackFavoriteAction } from 'containers/Favorites/utils';

export const PARSED_TYPES_MAP = {
  app: 'Apps',
  book: 'Books',
  podcast: 'Podcasts',
  video: 'Videos',
  topic: 'Topics',
  link: 'Links',
  person: 'People',
  article: 'Articles',
  organization: 'Organizations',
  list: 'Lists',
  program: 'Online Programs',
  assessment: 'Assessments',
  source: 'Sources',
  services: 'Services',
  series: 'Series',
  course: 'Courses',
};

export const useSaveToFavorite = ({ item, type, trackingPath }) => {
  const savedResources = useSelector(state => state.resources.savedResources);
  const dispatch = useDispatch();
  const auth = useSelector(state => state.firebase.auth);
  const { slug, title, name } = item;
  const id = item.objectID || item.id;

  const saved = isResourceSaved(savedResources, {
    id,
  });

  const handleSave = e => {
    e.preventDefault();
    e.stopPropagation();

    let nodeID;
    if (saved) [{ nodeID }] = savedResources.filter(el => el.resourceID === id);

    const saveData = {
      nodeID,
      resource: {
        type: PARSED_TYPES_MAP[type] || type,
        resourceID: id,
        slug,
        name: name || title,
        ...(trackingPath && { path: trackingPath }),
      },
      save: !saved,
      isList: type === 'list',
    };
    trackFavoriteAction('Resource Card', saveData.resource, auth, saved);
    dispatch(saveResource(saveData));
  };

  return { saved, handleSave };
};
